import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import * as api from "../api";

const infos = [
  {
    titre: "Adresse",
    valeur: " Oran , Algérie",
    icon: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z"
  },
  {
    titre: "Téléphone",
    valeur: "+213 555 000 000",
    icon: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
  },
  {
    titre: "Email",
    valeur: "contact@marinadz.com",
    icon: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
  },
  {
    titre: "Horaires",
    valeur: "Dim - Jeu : 9h00 - 17h00",
    icon: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
  }
];

const sujets = [
  "Question générale",
  "Problème technique",
  "Devenir exposant",
  "Signaler une annonce",
  "Partenariat",
  "Presse / Médias",
  "Autre"
];

function Contact() {
  const [form, setForm] = useState({ nom: "", email: "", telephone: "", sujet: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nom || !form.email || !form.message) {
      setError("Nom, email et message sont obligatoires.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await api.sendContact(form);
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.message || "Erreur lors de l'envoi, veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  const s = {
    page: { display: "flex", flexDirection: "column", minHeight: "100vh", fontFamily: "Arial, sans-serif" },
    main: { flex: 1, backgroundColor: "#f9fafb", padding: isMobile ? "20px 16px" : "40px 20px" },
    container: { maxWidth: "1100px", margin: "0 auto" },
    header: { textAlign: "center", marginBottom: isMobile ? "24px" : "48px" },
    title: { fontSize: isMobile ? "24px" : "36px", fontWeight: "800", color: "#1f2937", margin: "0 0 8px" },
    subtitle: { color: "#6b7280", fontSize: isMobile ? "14px" : "16px" },
    grid: { display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1.5fr", gap: "32px", alignItems: "start" },
    infoCard: { backgroundColor: "#0d9488", borderRadius: "16px", padding: "32px 28px", color: "white" },
    infoItem: { display: "flex", gap: "16px", marginBottom: "24px", alignItems: "flex-start" },
    infoIcon: { width: "44px", height: "44px", backgroundColor: "rgba(255,255,255,0.15)", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
    formCard: { backgroundColor: "white", borderRadius: "16px", padding: isMobile ? "24px 20px" : "36px 32px", boxShadow: "0 2px 12px rgba(0,0,0,0.08)" },
    label: { display: "block", fontWeight: "600", fontSize: "14px", color: "#374151", marginBottom: "6px" },
    input: { width: "100%", padding: "12px 14px", border: "1px solid #d1d5db", borderRadius: "8px", fontSize: "14px", color: "#1f2937", outline: "none", boxSizing: "border-box" },
    textarea: { width: "100%", padding: "12px 14px", border: "1px solid #d1d5db", borderRadius: "8px", fontSize: "14px", color: "#1f2937", resize: "vertical", outline: "none", boxSizing: "border-box", minHeight: "130px" },
    row: { display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "16px", marginBottom: "16px" },
    fieldWrap: { marginBottom: "16px" },
    btn: { width: "100%", padding: "14px", border: "none", borderRadius: "10px", backgroundColor: "#0d9488", color: "white", fontSize: "15px", fontWeight: "700", cursor: loading ? "default" : "pointer", opacity: loading ? 0.8 : 1 },
    successWrap: { flex: 1, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#f9fafb" },
    successBox: { textAlign: "center", backgroundColor: "white", padding: "60px 40px", borderRadius: "20px", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", maxWidth: "480px", width: "100%" },
  };

  if (submitted) return (
    <div style={s.page}>
      <Navbar />
      <div style={s.successWrap}>
        <div style={s.successBox}>
          <div style={{ width: "80px", height: "80px", borderRadius: "50%", backgroundColor: "#f0fdfa", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="#0d9488"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
          </div>
          <h2 style={{ fontSize: "24px", fontWeight: "700", color: "#1f2937", marginBottom: "12px" }}>Message envoyé ! ✅</h2>
          <p style={{ color: "#6b7280", fontSize: "15px", lineHeight: "1.6", marginBottom: "12px" }}>
            Votre message a bien été reçu. Nous vous répondrons dans les plus brefs délais.
          </p>
          <p style={{ color: "#9ca3af", fontSize: "13px" }}>Un email de confirmation a été envoyé à <strong>{form.email}</strong></p>
          <button onClick={() => { setSubmitted(false); setForm({ nom: "", email: "", telephone: "", sujet: "", message: "" }); }} style={{ marginTop: "24px", background: "#0d9488", color: "white", border: "none", padding: "12px 28px", borderRadius: "10px", cursor: "pointer", fontWeight: "600" }}>
            Envoyer un autre message
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );

  return (
    <div style={s.page}>
      <Navbar />
      <main style={s.main}>
        <div style={s.container}>
          <div style={s.header}>
            <h1 style={s.title}>Contactez-nous 📩</h1>
            <p style={s.subtitle}>Notre équipe est là pour vous aider. Réponse sous 24h.</p>
          </div>
          <div style={s.grid}>
            {/* Infos */}
            <div style={s.infoCard}>
              <h3 style={{ margin: "0 0 24px", fontSize: "20px", fontWeight: "700" }}>Nos coordonnées</h3>
              {infos.map((info) => (
                <div key={info.titre} style={s.infoItem}>
                  <div style={s.infoIcon}>
                    <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="white" strokeWidth="2">
                      {info.icon.split(" M").map((d, i) => (
                        <path key={i} strokeLinecap="round" strokeLinejoin="round" d={i === 0 ? d : "M" + d} />
                      ))}
                    </svg>
                  </div>
                  <div>
                    <p style={{ margin: "0 0 2px", fontSize: "12px", opacity: 0.7, fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.5px" }}>{info.titre}</p>
                    <p style={{ margin: 0, fontSize: "15px", fontWeight: "600" }}>{info.valeur}</p>
                  </div>
                </div>
              ))}
              <div style={{ marginTop: "24px", paddingTop: "24px", borderTop: "1px solid rgba(255,255,255,0.2)" }}>
                <p style={{ margin: "0 0 12px", fontSize: "14px", opacity: 0.85 }}>Suivez-nous :</p>
                <div style={{ display: "flex", gap: "12px" }}>
                  {["Facebook", "LinkedIn", "Instagram"].map(s => (
                    <span key={s} style={{ background: "rgba(255,255,255,0.15)", padding: "6px 14px", borderRadius: "20px", fontSize: "13px", fontWeight: "600" }}>{s}</span>
                  ))}
                </div>
              </div>
            </div>

            {/* Formulaire */}
            <div style={s.formCard}>
              <h3 style={{ margin: "0 0 24px", fontSize: "20px", fontWeight: "700", color: "#1f2937" }}>Envoyer un message</h3>
              {error && <p style={{ color: "#dc2626", fontSize: "14px", marginBottom: "12px" }}>{error}</p>}
              <div style={s.row}>
                <div>
                  <label style={s.label}>Nom complet *</label>
                  <input name="nom" value={form.nom} onChange={handleChange} placeholder="Votre nom" style={s.input} required />
                </div>
                <div>
                  <label style={s.label}>Email *</label>
                  <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="votre@email.com" style={s.input} required />
                </div>
              </div>
              <div style={s.row}>
                <div>
                  <label style={s.label}>Téléphone</label>
                  <input name="telephone" value={form.telephone} onChange={handleChange} placeholder="+213 555 000 000" style={s.input} />
                </div>
                <div>
                  <label style={s.label}>Sujet</label>
                  <select name="sujet" value={form.sujet} onChange={handleChange} style={{ ...s.input, background: "white" }}>
                    <option value="">Sélectionner...</option>
                    {sujets.map(sj => <option key={sj} value={sj}>{sj}</option>)}
                  </select>
                </div>
              </div>
              <div style={s.fieldWrap}>
                <label style={s.label}>Message *</label>
                <textarea name="message" value={form.message} onChange={handleChange} placeholder="Décrivez votre demande..." style={s.textarea} required />
              </div>
              <button onClick={handleSubmit} disabled={loading} style={s.btn}>
                {loading ? "Envoi en cours..." : "Envoyer le message 📩"}
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Contact;